import React from 'react'
import PropTypes from 'prop-types'
import CheckboxSetting from '../CheckboxSetting'
import styles from '../../../../styles.scss'

const RunClientsWithLogging = (props) => {
    const settings = {
        id: 'runWithLogs',
        name: 'LauncherRunClientsWithLogging',
        className: styles.checkbox,
        label: props.label,
        value: props.value,
        update: (value) => {
            props.save(value)
            props.showMessage()
        },
    }

    return <CheckboxSetting {...settings} />
}

RunClientsWithLogging.propTypes = {
    label: PropTypes.string,
    value: PropTypes.bool,
    save: PropTypes.func,
    showMessage: PropTypes.func,
}

export default RunClientsWithLogging



// WEBPACK FOOTER //
// ./src/features/Settings/components/Settings/components/RunClientsWithLogging/component.js